import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { _T } from "../../base-react/src/Localization";
import { ManagerMenu } from './ManagerMenu';
import { Sider } from './Sider';
import { Alert, Grid, Layout, theme } from 'antd';
import { BaseMenu } from '../../base-react/components/BaseMenu';
import { Upcoming } from './Upcoming';
import { useCompetition } from '../../base-react/hooks/Competition';
import { OnboardingDrawer } from './OnboardingDrawer';
const { Header, Content } = Layout;
const { useToken } = theme;
const { useBreakpoint } = Grid;
export function Dashboard() {
    const { token } = useToken();
    let { event_id } = useParams();
    const [, event] = useCompetition(event_id);
    const screens = useBreakpoint();
    const docsMenuItem = {
        key: "docs",
        label: (React.createElement("a", { href: "https://docs.vote4dance.com", target: "_blank", rel: "noopener noreferrer" }, _T('header.docs'))),
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("style", null, `@media print { .manager-left-sider, .manager-right-upcoming { display: none !important; } }`),
        React.createElement(Layout, { hasSider: !!(event_id && !screens.xs), style: { minHeight: '100vh' } },
            event_id && !screens.xs &&
                React.createElement(Sider, { event_id: event_id }),
            React.createElement(Layout, { style: { backgroundColor: token.colorBgBase } },
                React.createElement(Header, { style: screens.xs ? {
                        position: 'sticky',
                        padding: 0,
                        top: 0,
                        zIndex: 10,
                        backgroundColor: token.colorBgBase
                    } : {
                        backgroundColor: token.colorBgBase
                    } }, event_id ? React.createElement(ManagerMenu, { event_id: event_id }) : React.createElement(BaseMenu, { logo: true, children: [docsMenuItem] })),
                React.createElement(Content, null,
                    event && event.competition_level === 0 &&
                        React.createElement(Alert, { title: _T('limits.title'), description: _T('limits.extra'), type: "warning", showIcon: true, style: { margin: 24 } }),
                    React.createElement(Outlet, null))),
            event_id &&
                React.createElement(OnboardingDrawer, { event_id: event_id }),
            event_id && !screens.xs &&
                React.createElement(Upcoming, { event_id: event_id }))));
}
